import { render, staticRenderFns } from "./DialogWrapper.vue?vue&type=template&id=bc3b2c8a"
import script from "./DialogWrapper.vue?vue&type=script&lang=js"
export * from "./DialogWrapper.vue?vue&type=script&lang=js"
import style0 from "./DialogWrapper.vue?vue&type=style&index=0&id=bc3b2c8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports